



















































































































































































import { Component, Vue } from 'vue-property-decorator';
import {
  Representative,
  CustomAttribute,
  CustomTile,
  TaskDetailParam,
  TaskName,
  ColumnSwitch,
  AttributeName,
  TaskAttributeGroup,
  TaskChildViewAttributeGroup,
} from '@/@types/LibraryComponent';
import TaskListTable from '@/components/taskList/TaskListTable.vue';
import TaskGroupView from '@/components/taskList/TaskGroupView.vue';
import CommonMenuNavigationDrawer from '@/components/common/CommonMenuNavigationDrawer.vue';
import TaskFilter from '@/components/taskList/TaskFilter.vue';
import TaskGroupChildTable from '@/components/taskList/TaskGroupChildTable.vue';
import TaskAddModal from '@/components/taskList/taskAddModal/TaskAddModalBase.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import SelectMenu from '@/components/taskList/taskListTableParts/SelectMenu.vue';
import GanttChartView from '@/components/taskList/chartView/GanttChartViewBase.vue'
import { ColorCalculator } from '@/shared/GetBackgoundColor';
import {
  TasksType,
  FindTasksQuery,
  TasksPagination,
  UpdateTaskParam,
  UpdateTaskCustomAttributesParam,
  CreateTaskParam,
  UpdateModeTaskQuery,
} from '@/@types/Task';
import { ProjectMemberResponse } from '@/@types/ProjectMember';
import { UpdateMode, valueof, MessageCategoryCd } from '@/@types/Common';
import {
  Project,
  UpdateProjectCustomAttributesParam,
  TaskAttributeValueOption,
  FindOneProjectQuery,
  ProjectGetMode,
} from '@/@types/Project';
import { vxm } from '@/store';
import { CreateActivityDto } from '@/@types/activity';
import {
  ActivityKindCd,
  AttributeCd,
  NotificationKindCd,
  NotificationKindId,
} from '@/@types/constant';
import { CreateNotificationDto } from '@/@types/Notification';

const VIEW_COMPONENT_NAME = {
  TABLE: 'table',
  GROUP: 'group',
  CHART: 'chart',
} as const;

@Component({
  components: {
    TaskListTable,
    CommonMenuNavigationDrawer,
    TaskFilter,
    TaskGroupView,
    TaskGroupChildTable,
    TaskAddModal,
    CommonButton,
    SelectMenu,
    GanttChartView,
  },
})
export default class TaskList extends Vue {
  /** プロジェクトのカスタム属性のうち、値が設定されているものの配列 */
  private customAttributes: CustomAttribute[] = [];
  /** 課題属性値選択項目の項目・背景色・フォントカラーの配列 */
  private customTiles: CustomTile[] = [];
  private taskChildViewAttributeGroups: TaskChildViewAttributeGroup[] = [];
  private attributeTitles: valueof<keyof typeof AttributeCd>[] = [];
  private attributeTitle: valueof<keyof typeof AttributeCd> =
    AttributeCd.status;
  private isOpenTaskAddModal: boolean = false;
  // v-menuのv-model
  private iconClass: string = 'mr-1';
  private iconSize: number = 17;
  /** プロジェクトのデフォルト属性に表示フラグがまだ無く動的に取得できないため、全てtrueを初期値にしておく */
  private defaultDisplayFlag: boolean = true;
  private views: Array<{ title: string; icon: string }> = [
    { title: 'テーブル', icon: 'format-list-bulleted' },
    { title: 'グループ', icon: 'view-list' },
    { title: 'ガントチャート', icon: 'chart-gantt' },
  ];
  private fieldColumns: ColumnSwitch[] = [];
  private componentTitle: valueof<keyof typeof VIEW_COMPONENT_NAME>  = 'table';
  private fieldIcon: string = 'mdi-dots-grid';
  private components: Array<typeof TaskListTable | typeof TaskGroupView> = [
    TaskListTable,
    TaskGroupView,
  ];
  private partUpdateModeTaskQuery: UpdateModeTaskQuery = {
    'update-mode': UpdateMode.part,
    'project-id': this.projectId,
  };
  private findQuery = {
    'project-id': this.projectId,
  };
  private findOneProjectQuery: FindOneProjectQuery = {
    'get-mode': ProjectGetMode.all,
  };

  private async created() {
    await Promise.all([
      vxm.theoryApi.tasksStore.fetchTasks(this.findQuery),
      vxm.theoryApi.projectMembersStore.fetchProjectMembers(this.findQuery),
      vxm.theoryApi.projectsStore.fetchProject({
        projectId: this.projectId,
        query: this.findOneProjectQuery,
      }),
      vxm.theoryApi.projectsStore.fetchTaskAttributeValueOptions(this.projectId),
    ]);
    this.customAttributes = this.getCustomAttributes(this.project);
    this.taskChildViewAttributeGroups = this.getTaskChildViewAttributeGroups();
    this.customTiles = this.getTiles();
    this.fieldColumns = this.getFieldColumn(this.project);
  }

  private getTaskChildViewAttributeGroups() {
    const attributeGroups: TaskChildViewAttributeGroup[] = [];
    const attributeCds: valueof<
      keyof typeof AttributeCd
    >[] = this.taskAttributeValueOptions.map((value) => {
      return value.attributeCd;
    });
    this.attributeTitles = [...new Set(attributeCds)];
    attributeCds.forEach((cd) => {
      const taskAttributeGroups: TaskAttributeGroup[] = [];
      this.taskAttributeValueOptions.forEach((value) => {
        if (value.attributeCd === cd) {
          taskAttributeGroups.push({
            taskAttributeValueOptionId: value.taskAttributeValueOptionId,
            title: value.value,
            backgroundColor: ColorCalculator.getBackgroundColorCss(
              value.colorCd
            ),
            fontColor: value.colorCd,
            descriptionText: value.attributeItemContent,
            isHelp: false,
            isOpenView: false,
          });
        }
      });
      attributeGroups.push({
        attributeCd: cd,
        attributes: taskAttributeGroups,
      });
    });
    return attributeGroups;
  }

  /**  タスク追加モーダルの切替 */
  private openTaskAddModal(): void {
    this.isOpenTaskAddModal = true;
  }

  /**  タスク追加モーダルの切替 */
  private closeTaskAddModal(): void {
    this.isOpenTaskAddModal = false;
  }

  private onChangeView(viewTitle: string): void {
    if (viewTitle === 'テーブル') {
      this.componentTitle = VIEW_COMPONENT_NAME.TABLE;
    } else if (viewTitle === 'グループ') {
      this.componentTitle = VIEW_COMPONENT_NAME.GROUP;
    } else if (viewTitle === 'ガントチャート') {
      this.componentTitle = VIEW_COMPONENT_NAME.CHART;
    } else return;
  }

  private onChangeAttributeTitle(title: string) {
    this.attributeTitle = title;
  }

  /** 課題登録API実行 */
  private async createTask(param: CreateTaskParam) {
    const createTaskResponse = await vxm.theoryApi.tasksStore.createTask(param);
    /** アクティビティを登録 */
    if (createTaskResponse) {
      const createActivitiesParam: CreateActivityDto = {
        activityKindCd: ActivityKindCd.addTask,
        actionAccountId: this.accountId,
        projectId: this.projectId,
        projectName: this.project?.projectName as string,
        taskId: createTaskResponse.results.taskId,
        taskName: createTaskResponse.results.taskName,
        taskCommentId: null,
        accountId: null,
        shiftId: null,
        messageId: null,
        branchId: null,
        pullrequestId: null,
        pullrequestCommentId: null,
        documentGroupId: null,
        documentId: null,
        commentContent: null,
        status: null,
      };
      await vxm.theoryApi.activitiesStore.createActivity(createActivitiesParam);
      /** 担当者または実施者を設定している場合、通知を登録 */
      if (param.currentResponsiblePersonId != null) {
        const targetAccountName = await vxm.theoryApi.notificationsStore.fetchNotificationTargetAccountName(
          param.currentResponsiblePersonId,
        );
        const createNotificationParam: CreateNotificationDto = {
          notificationKindId: NotificationKindId.addTaskResponsible,
          projectId: this.projectId,
          notificationTargetAccountId: param.currentResponsiblePersonId,
          notificationTargetAccountName: targetAccountName.results.accountName,
          actionAccountId: this.accountId,
          actionAccountName: vxm.theoryApi.authStore.getCurrentUserInfo?.results.accountName as string,
          projectName: this.project?.projectName as string,
          organizationId: vxm.theoryApi.authStore.getCurrentOrganizationId as number,
          taskId: createTaskResponse.results.taskId,
          projectTaskId: createTaskResponse.results.projectTaskId,
          taskName: createTaskResponse.results.taskName,
          taskDetail: param.taskDetail,
        };
        await this.createNotification(createNotificationParam);
      }
      if (param.practitionerId != null) {
        const targetAccountName = await vxm.theoryApi.notificationsStore.fetchNotificationTargetAccountName(
          param.practitionerId,
        );
        const createNotificationParam: CreateNotificationDto = {
          notificationKindId: NotificationKindId.addTaskPractitioner,
          projectId: this.projectId,
          notificationTargetAccountId: param.practitionerId,
          notificationTargetAccountName: targetAccountName.results.accountName,
          actionAccountId: this.accountId,
          actionAccountName: vxm.theoryApi.authStore.getCurrentUserInfo?.results.accountName as string,
          projectName: this.project?.projectName as string,
          organizationId: vxm.theoryApi.authStore.getCurrentOrganizationId as number,
          taskId: createTaskResponse.results.taskId,
          projectTaskId: createTaskResponse.results.projectTaskId,
          taskName: createTaskResponse.results.taskName,
          taskDetail: param.taskDetail,
        };
        await this.createNotification(createNotificationParam);
      }
      for (let i = 0; i < 30; i++) {
        if (param[`customAttribute${i}ValuePerson`] != null) {
          const targetAccountName = await vxm.theoryApi.notificationsStore.fetchNotificationTargetAccountName(
            param[`customAttribute${i}ValuePerson`] as number,
          );
          const createNotificationParam: CreateNotificationDto = {
            notificationKindId: NotificationKindId.addTaskCustom,
            projectId: this.projectId,
            notificationTargetAccountId: param[`customAttribute${i}ValuePerson`] as number,
            notificationTargetAccountName: targetAccountName.results.accountName,
            actionAccountId: this.accountId,
            actionAccountName: vxm.theoryApi.authStore.getCurrentUserInfo?.results.accountName as string,
            projectName: this.project?.projectName as string,
            organizationId: vxm.theoryApi.authStore.getCurrentOrganizationId as number,
            taskId: createTaskResponse.results.taskId,
            projectTaskId: createTaskResponse.results.projectTaskId,
            taskName: createTaskResponse.results.taskName,
            taskDetail: param.taskDetail,
            taskAttributeName: this.project[`customAttribute${i}Name`],
          };
          await this.createNotification(createNotificationParam);
          break;
        }
      }
    }
    await vxm.theoryApi.tasksStore.fetchTasks(this.findQuery);
    this.isOpenTaskAddModal = false;
  }

  /**通知作成処理 */
  async createNotification(param: CreateNotificationDto) {
    await vxm.theoryApi.notificationsStore.createNotification(param);
  }

  /** 渡された属性名から更新用のパラメータを作成して更新APIを実行する */
  private async onUpdateTask(value: TaskDetailParam) {
    /** カスタム属性フラグがfalseの場合、課題更新APIを実行 */
    if (!value.customFlag) {
      let param: UpdateTaskParam = {};
      param[`${value.attributeKey}`] = value.value;
      await this.updateTask({ id: value.taskId as number, param: param });
    } else {
      /** カスタム属性フラグがtrueの場合、課題カスタム属性更新APIを実行 */
      let param: UpdateTaskCustomAttributesParam = {};
      param[`${value.attributeKey}`] = value.value;
      await this.updateTaskCustomAttributes({
        id: value.taskId as number,
        param: param,
      });
    }
    return;
  }

  /** 課題更新 */
  private async updateTask(params: { id: number; param: UpdateTaskParam }) {
    const taskId: number = params.id;
    const updateTaskResponse = await vxm.theoryApi.tasksStore.updateTask({
      taskId: taskId,
      param: params.param,
      query: this.partUpdateModeTaskQuery,
    });
    if (updateTaskResponse) {
      /** アクティビティを登録 */
      const createActivitiesParam: CreateActivityDto = {
        activityKindCd: ActivityKindCd.updateTask,
        actionAccountId: this.accountId,
        projectId: this.projectId,
        projectName: this.project?.projectName as string,
        taskId: updateTaskResponse.results.taskId,
        taskName: updateTaskResponse.results.taskName,
        taskCommentId: null,
        accountId: null,
        shiftId: null,
        messageId: null,
        branchId: null,
        pullrequestId: null,
        pullrequestCommentId: null,
        documentGroupId: null,
        documentId: null,
        commentContent: null,
        status: null,
      };
      await vxm.theoryApi.activitiesStore.createActivity(createActivitiesParam);
      /** 担当者または実施者を設定している場合、通知を登録 */
      if (params.param.currentResponsiblePersonId != null) {
        const createNotificationParam: CreateNotificationDto = {
          notificationKindId: NotificationKindId.updateTaskResponsible,
          projectId: this.projectId,
          notificationTargetAccountId: params.param.currentResponsiblePersonId,
          actionAccountId: this.accountId,
          actionAccountName: vxm.theoryApi.authStore.getCurrentUserInfo?.results.accountName as string,
          projectName: this.project?.projectName as string,
          organizationId: vxm.theoryApi.authStore.getCurrentOrganizationId as number,
          taskId: updateTaskResponse.results.taskId,
          projectTaskId: updateTaskResponse.results.projectTaskId,
          taskName: updateTaskResponse.results.taskName,
        };
        await this.createNotification(createNotificationParam);
      }
      if (params.param.practitionerId != null) {
        const createNotificationParam: CreateNotificationDto = {
          notificationKindId: NotificationKindId.addTaskPractitioner,
          projectId: this.projectId,
          notificationTargetAccountId: params.param.practitionerId,
          actionAccountId: this.accountId,
          actionAccountName: vxm.theoryApi.authStore.getCurrentUserInfo?.results.accountName as string,
          projectName: this.project?.projectName as string,
          organizationId: vxm.theoryApi.authStore.getCurrentOrganizationId as number,
          taskId: updateTaskResponse.results.taskId,
          projectTaskId: updateTaskResponse.results.projectTaskId,
          taskName: updateTaskResponse.results.taskName,
        };
        await this.createNotification(createNotificationParam);
      }
    }
    await Promise.all([
      vxm.theoryApi.tasksStore.fetchTasks(this.findQuery),
      vxm.theoryApi.tasksStore.fetchTask({
        taskId: taskId,
        query: { 'project-id': this.projectId },
      }),
    ]);
  }

  /** 課題カスタム属性更新 */
  private async updateTaskCustomAttributes(params: {
    id: number;
    param: UpdateTaskCustomAttributesParam;
  }) {
    const taskId: number = params.id;
    const updateResult = await vxm.theoryApi.tasksStore.updateTaskCustomAttributes({
      taskId: taskId,
      param: params.param,
      query: this.partUpdateModeTaskQuery,
    });
    if (updateResult) {
      /** アクティビティを登録 */
      const createActivitiesParam: CreateActivityDto = {
        activityKindCd: ActivityKindCd.updateTask,
        actionAccountId: this.accountId,
        projectId: this.projectId,
        projectName: this.project?.projectName as string,
        taskId: updateResult.results.taskId,
        taskName: updateResult.results.taskName,
        taskCommentId: null,
        accountId: null,
        shiftId: null,
        messageId: null,
        branchId: null,
        pullrequestId: null,
        pullrequestCommentId: null,
        commentContent: null,
        status: null,
      };
      await vxm.theoryApi.activitiesStore.createActivity(createActivitiesParam);
      /**通知を登録 */
      for (let i = 0; i < 30; i++) {
        if (params.param[`customAttribute${i}ValuePerson`] != null) {
          const createNotificationParam: CreateNotificationDto = {
            notificationKindId: NotificationKindId.updateTaskCustom,
            projectId: this.projectId,
            notificationTargetAccountId: params.param[`customAttribute${i}ValuePerson`] as number,
            actionAccountId: this.accountId,
            actionAccountName: vxm.theoryApi.authStore.getCurrentUserInfo?.results.accountName as string,
            projectName: this.project?.projectName as string,
            organizationId: vxm.theoryApi.authStore.getCurrentOrganizationId as number,
            taskId: updateResult.results.taskId,
            projectTaskId: updateResult.results.projectTaskId,
            taskName: updateResult.results.taskName,
            taskAttributeName: this.project[`customAttribute${i}Name`],
          };
          await this.createNotification(createNotificationParam);
          break;
        }
      }
    }
    await vxm.theoryApi.tasksStore.fetchTasks(this.findQuery);
  }

  /** 絞り込み条件を指定して課題一覧の状態を更新 */
  private async sortTasks(query: FindTasksQuery) {
    await vxm.theoryApi.tasksStore.fetchTasks(query);
  }

  /** プロジェクトの属性表示フラグ更新用のパラメータを生成して更新APIを実行 */
  private async onUpdateProjectCustomAttributesDisplayFlag(
    attributeNumber: number,
    value: boolean
  ) {
    if (attributeNumber === 0) {
      return;
    }
    let updateParam: UpdateProjectCustomAttributesParam = {};
    updateParam[`customAttribute${attributeNumber}DisplayFlag`] = value;
    await vxm.theoryApi.projectsStore.updateProjectCustomAttributes({
      projectId: this.projectId,
      param: updateParam,
      query: { 'update-mode': 'part' },
    });
    await vxm.theoryApi.projectsStore.fetchProject({
      projectId: this.projectId,
      query: this.findOneProjectQuery,
    });
    return;
  }

  /** プロジェクトから、設定済みのカスタム属性の一覧を取得 */
  private getCustomAttributes(project: Project | undefined): CustomAttribute[] {
    if (!project) {
      return [];
    } else {
      const keys = Object.keys(project).filter((key) => {
        return key.substr(0, 6) === 'custom' && key.substr(-4, 4) === 'Flag';
      });
      /** プロジェクトの全カスタム属性のうち、値が設定されている属性の数値を取得 */
      let attributeNumbers: number[] = [];
      keys.forEach((key, index) => {
        const number = index + 1;
        if (
          project[`customAttribute${number}Name`] != null &&
          project[`customAttribute${number}Name`].length > 0
        ) {
          attributeNumbers.push(number);
        }
      });
      if (attributeNumbers.length === 0) return [];
      const attributes: CustomAttribute[] = attributeNumbers.map((number) => {
        return {
          attributeNumber: number,
          name: project[`customAttribute${number}Name`],
          style: project[`customAttribute${number}Style`],
          displayStyle: project[`customAttribute${number}DisplayStyle`],
          displayFlag: project[`customAttribute${number}DisplayFlag`],
        };
      });
      return attributes;
    }
  }

  /** 課題属性値選択項目から、項目値と色の情報を取得 */
  private getTiles(): CustomTile[] {
    /** 対応する各カスタム属性名の数字部分を配列で取得 */
    const attributeNumbers: number[] = this.taskAttributeValueOptions.map(
      (option) => {
        return Number(option.attributeCd.toString().substr(-1, 1));
      }
    );
    /** TaskAttributeValueOption配列型に整形 */
    return attributeNumbers.map((number) => {
      const filteredAttributes = this.taskAttributeValueOptions.filter(
        (option) => {
          return Number(option.attributeCd.toString().substr(-1, 1)) === number;
        }
      );
      const tiles = filteredAttributes.map((attribute) => {
        return {
          taskAttributeValueOptionId: attribute.taskAttributeValueOptionId,
          title: attribute.value,
          backgroundColor: ColorCalculator.getBackgroundColorCss(
            attribute.colorCd
          ),
          fontColor: attribute.colorCd,
        };
      });
      return {
        attributeNumber: number,
        customTiles: tiles,
      };
    });
  }

  private getFieldColumn(project: Project | undefined): ColumnSwitch[] {
    /** 最終的にはdefaultDisplayFlagの部分をprojectテーブルの各表示フラグから取得する */
    let columnSwitches: ColumnSwitch[] = [];
    const defaultColumnSwitches: ColumnSwitch[] = [
      {
        attributeNumber: 0,
        attributeName: AttributeName.taskId,
        displayFlag: this.defaultDisplayFlag,
      },
      {
        attributeNumber: 0,
        attributeName: AttributeName.taskName,
        displayFlag: this.defaultDisplayFlag,
      },
      {
        attributeNumber: 0,
        attributeName: AttributeName.category,
        displayFlag: this.defaultDisplayFlag,
      },
      {
        attributeNumber: 0,
        attributeName: AttributeName.currentResponsiblePerson,
        displayFlag: this.defaultDisplayFlag,
      },
      {
        attributeNumber: 0,
        attributeName: AttributeName.priority,
        displayFlag: this.defaultDisplayFlag,
      },
      {
        attributeNumber: 0,
        attributeName: AttributeName.status,
        displayFlag: this.defaultDisplayFlag,
      },
      {
        attributeNumber: 0,
        attributeName: AttributeName.practitioner,
        displayFlag: this.defaultDisplayFlag,
      },
      {
        attributeNumber: 0,
        attributeName: AttributeName.startDate,
        displayFlag: this.defaultDisplayFlag,
      },
      {
        attributeNumber: 0,
        attributeName: AttributeName.deadline,
        displayFlag: this.defaultDisplayFlag,
      },
      {
        attributeNumber: 0,
        attributeName: AttributeName.scheduledTime,
        displayFlag: this.defaultDisplayFlag,
      },
      {
        attributeNumber: 0,
        attributeName: AttributeName.completedTime,
        displayFlag: this.defaultDisplayFlag,
      },
    ];
    columnSwitches = columnSwitches.concat(defaultColumnSwitches);
    if (project) {
      const keys = Object.keys(project).filter((key) => {
        return key.substr(0, 6) === 'custom' && key.substr(-4, 4) === 'Flag';
      });
      /** プロジェクトの全カスタム属性のうち、値が設定されている属性の数値を取得 */
      let attributeNumbers: number[] = [];
      keys.forEach((key, index) => {
        if (project[`customAttribute${index + 1}Name`]) {
          attributeNumbers.push(index + 1);
        }
      });
      if (attributeNumbers.length !== 0) {
        const customColumnSwitches: ColumnSwitch[] = attributeNumbers.map(
          (number) => {
            return {
              attributeNumber: number,
              attributeName: project[`customAttribute${number}Name`],
              displayFlag: project[`customAttribute${number}DisplayFlag`],
            };
          }
        );
        columnSwitches = columnSwitches.concat(customColumnSwitches);
      }
    }
    return columnSwitches;
  }

  private async reloadProjectAttribute() {
    await vxm.theoryApi.projectsStore.fetchProject({
      projectId: this.projectId,
      query: this.findOneProjectQuery,
    });
    await vxm.theoryApi.projectsStore.fetchTaskAttributeValueOptions(this.projectId);
    this.customAttributes = this.getCustomAttributes(this.project);
    this.customTiles = this.getTiles();
    this.fieldColumns = this.getFieldColumn(this.project);
  }

  private createMessage(
    accountName: string,
    category: valueof<keyof typeof MessageCategoryCd>
  ) {
    let message = '';
    switch (category) {
      case MessageCategoryCd.currentResponsiblePerson:
        message = `【作業担当者：${accountName}】`;
        break;
      case MessageCategoryCd.notCurrentResponsiblePerson:
        message = `【作業担当者：未設定】`;
        break;
      case MessageCategoryCd.practitioner:
        message = `【作業実施者：${accountName}】`;
        break;
      case MessageCategoryCd.notPractitioner:
        message = `【作業実施者：未設定】`;
        break;
      case MessageCategoryCd.member:
        message = `【メンバー：${accountName}】`;
        break;
    }
    return message;
  }

  private get taskComponent(): typeof TaskListTable | typeof TaskGroupView | typeof GanttChartView{
    if (this.componentTitle === VIEW_COMPONENT_NAME.TABLE) {
      return TaskListTable;
    } else if (this.componentTitle === VIEW_COMPONENT_NAME.GROUP) {
      return TaskGroupView;
    } else {
      return GanttChartView;
    }
  }

  private get tasksData(): TasksType[] {
    const response = vxm.theoryApi.tasksStore.getTasks;
    if (response) {
      return response.results;
    } else return [];
  }

  private get pagination(): TasksPagination | null {
    return vxm.theoryApi.tasksStore.getTasks ? vxm.theoryApi.tasksStore.getTasks.pagination : null;
  }

  private get representatives(): Representative[] {
    const projectMembers: ProjectMemberResponse[] = vxm.theoryApi.projectMembersStore
      .getProjectMembers
      ? vxm.theoryApi.projectMembersStore.getProjectMembers.results
      : [];
    const representatives = projectMembers.map((member) => {
      return {
        projectMemberId: member.projectMemberId,
        accountId: member.accountId,
        accountName: member.accountName,
        role: member.roleCd,
      };
    });
    representatives.push({
      projectMemberId: 0,
      accountId: 0,
      accountName: '担当者なし',
      role: 'guest',
    });
    return representatives;
  }

  private get accountId() {
    const response = vxm.theoryApi.authStore.getCurrentUserInfo;
    if (response) {
      return response.results.accountId;
    } else return 0;
  }

  private get projectId() {
    return vxm.theoryApi.authStore.getCurrentProjectId as number;
  }

  private get project(): Project | undefined {
    return vxm.theoryApi.projectsStore.getProject?.results;
  }

  private get taskAttributeValueOptions(): TaskAttributeValueOption[] {
    const response = vxm.theoryApi.projectsStore.getTaskAttributeValueOptions;
    if (response) {
      return response.results;
    } else return [];
  }

  private get categories() {
    const categoriesGroup = this.taskChildViewAttributeGroups.find((group) => {
      return group.attributeCd === AttributeCd.category;
    });
    return categoriesGroup ? categoriesGroup.attributes : [];
  }

  private get priorities() {
    const prioritiesGroup = this.taskChildViewAttributeGroups.find((group) => {
      return group.attributeCd === AttributeCd.priority;
    });
    return prioritiesGroup ? prioritiesGroup.attributes : [];
  }

  private get statuses() {
    const statusesGroup = this.taskChildViewAttributeGroups.find((group) => {
      return group.attributeCd === AttributeCd.status;
    });
    return statusesGroup ? statusesGroup.attributes : [];
  }

  /** 課題追加モーダルに渡す課題IDと課題タイトルの配列 */
  private get taskNames(): TaskName[] {
    return this.tasksData.map((task) => {
      return {
        value: task.taskId,
        text: task.taskName,
        category: task.category,
        priority: task.priority,
        status: task.status,
      };
    });
  }
}
